module.exports = __webpack_public_path__ + "images/for_company_page/mnews_logo_cc1ab4146d96bb2e771c2b2c1022d62c.gif";